module.exports = __webpack_public_path__ + "img/content.f321ca1e.png";